module.exports = __webpack_public_path__ + "images/menu-user.svg?5ede638ecc6c95762e554921c97e4258";